import { render, staticRenderFns } from "./LayoutFull.vue?vue&type=template&id=57f8fc1c"
import script from "./LayoutFull.vue?vue&type=script&lang=js"
export * from "./LayoutFull.vue?vue&type=script&lang=js"
import style0 from "./LayoutFull.vue?vue&type=style&index=0&id=57f8fc1c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f8fc1c')) {
      api.createRecord('57f8fc1c', component.options)
    } else {
      api.reload('57f8fc1c', component.options)
    }
    module.hot.accept("./LayoutFull.vue?vue&type=template&id=57f8fc1c", function () {
      api.rerender('57f8fc1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/layout/LayoutFull.vue"
export default component.exports